import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.scss']
})
export class ErrorPageComponent implements OnInit {
  ngOnInit(): void {
    console.log('Error page has come :::::::::')
  }
  
  constructor(private router: Router) {}
  goHome() {
    this.router.navigate(['/']);
  }
  
}
